import React from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';

const CheckboxesQuestion = ({ label, value, setValue, settings }) => {
    value = value || [];

    return (
        <div>
            <QuestionLabel label={label} settings={settings} />
            <div>
                {settings?.options && (
                    <>
                        {getOptionsFromList(settings.options).map(
                            (opt, idx) => (
                                <label
                                    key={idx}
                                    className="flex items-center py-1"
                                >
                                    <input
                                        type="checkbox"
                                        value={opt}
                                        checked={value.indexOf(opt) > -1}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                setValue([...value, opt]);
                                            } else {
                                                const newValue = [...value];
                                                newValue.splice(
                                                    value.indexOf(opt),
                                                    1,
                                                );
                                                setValue(newValue);
                                            }
                                        }}
                                        className="mr-2"
                                    />
                                    {opt}
                                </label>
                            ),
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default CheckboxesQuestion;
